<dx-tabs
  class="flow-meter-report-tabs"
  [dataSource]="[{id: 0, text: 'Rapport'}, {id: 1, text: 'La Carte'}]"
  [selectedIndex]="0"
  (onItemClick)="selectTab($event)"
></dx-tabs>
<div style="position: relative" [ngClass]="{'hide-tab': selectedTab !== 0}">
  <app-flow-meter-metrics [width]="width" [height]="childHeight" [selected]="_selected" [loader]="loader"></app-flow-meter-metrics>
</div>
<div style="position: relative" [ngClass]="{'hide-tab': selectedTab !== 1}">
<!--  <app-flow-meter-heatmap [width]="width" [height]="childHeight" [loader]="loader"></app-flow-meter-heatmap>-->
</div>
